import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e9e8a28"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-home" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-2 font-bold" }, "Главная", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-chart-bar" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-2 font-bold" }, "Статистика", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-comments" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-2 font-bold" }, "Диалоги", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-cog" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-2 font-bold" }, "Настройки", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-sign-out" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-2 font-bold" }, "Выйти", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return ($setup.settings.isLoggedIn)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["h-full pb-7", {
      'logout-scale': $setup.settings.isLoggingOut,
      'menu-modal fixed w-17rem pt-8 px-2': $props.modal,
    }])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["h-full p-2 flex flex-column", { 'card blur menu-drawer': $props.modal }])
        }, [
          _createVNode(_component_Button, {
            class: "p-button-text p-button-secondary justify-content-center",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.menuClick(0)))
          }, {
            default: _withCtx(() => [
              _hoisted_1,
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(_component_Button, {
            class: "p-button-text p-button-secondary justify-content-center",
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.menuClick(1)))
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _hoisted_4
            ]),
            _: 1
          }),
          _createVNode(_component_Button, {
            class: "p-button-text p-button-secondary justify-content-center",
            onClick: _cache[2] || (_cache[2] = ($event: any) => ($options.menuClick(2)))
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _hoisted_6
            ]),
            _: 1
          }),
          _createVNode(_component_Button, {
            class: "p-button-text p-button-secondary justify-content-center",
            onClick: _cache[3] || (_cache[3] = ($event: any) => ($options.menuClick(99)))
          }, {
            default: _withCtx(() => [
              _hoisted_7,
              _hoisted_8
            ]),
            _: 1
          }),
          _hoisted_9,
          _createVNode(_component_Button, {
            class: "p-button-text p-button-danger justify-content-center",
            onClick: _cache[4] || (_cache[4] = ($event: any) => ($options.menuClick(100)))
          }, {
            default: _withCtx(() => [
              _hoisted_10,
              _hoisted_11
            ]),
            _: 1
          })
        ], 2)
      ], 2))
    : _createCommentVNode("", true)
}